import { render } from "./GoalTeamActivity.vue?vue&type=template&id=f430abba"
import script from "./GoalTeamActivity.vue?vue&type=script&lang=js"
export * from "./GoalTeamActivity.vue?vue&type=script&lang=js"
script.render = render

export default script